export const MESSAGES_LOADED = "messages/loaded"
export const MESSAGES_ADDED = "messages/messagesAdded"
export const MESSAGE_UPDATED = "messages/messageAdded"
export const MESSAGES_DELETED = "messages/messagesDeleted"